export default __webpack_public_path__ + "static/media/regulatory--keep-right--g5.f2e202d8.png";